import { ArrowDown, ArrowRight, Check, CheckCheck, Languages, Phone, PhoneCall } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { FreePlanNotice } from './FreePlanNotice';

export function Hero({ onCtaClick }: { onCtaClick: () => void }) {
    const { t } = useTranslation();
    return (
        <section className="landing-hero" aria-labelledby="hero-title">
            <div className="landing-container">
                <div className="landing-hero-grid">
                    <div className="landing-hero-copy">
                        <p className="landing-eyebrow"><span className="landing-status-dot" />{t('hero.eyebrow')}</p>
                        <h1 id="hero-title">{t('hero.headingLead')}<br /><em>{t('hero.headingAccent')}</em></h1>
                        <p className="landing-hero-description">{t('hero.subheading')}</p>
                        <div className="landing-hero-actions">
                            <button onClick={onCtaClick} className="landing-button">{t('hero.cta')}<ArrowRight size={18} aria-hidden="true" /></button>
                            <a href="#how-it-works" className="landing-text-link">{t('hero.secondaryCta')}<ArrowDown size={16} aria-hidden="true" /></a>
                        </div>
                        <p className="landing-hero-note"><Check size={15} aria-hidden="true" />{t('hero.freeNote')}</p>
                        <FreePlanNotice className="landing-free-plan-notice" />
                    </div>
                    <div className="landing-hero-visual">
                        <img src="/images/parentscheck-hero.jpg" alt={t('hero.illustrationAlt')} width="1200" height="1400" fetchPriority="high" loading="eager" decoding="async" />
                        <div className="landing-photo-label"><PhoneCall size={15} aria-hidden="true" />{t('hero.photoLabel')}</div>
                        <div className="landing-hero-report">
                            <div className="landing-hero-report-top"><span className="landing-report-icon"><CheckCheck size={18} aria-hidden="true" /></span><span>{t('hero.reportCard.label')}</span><span className="landing-example-tag">{t('hero.reportCard.example')}</span></div>
                            <h2>{t('hero.reportCard.mood')}</h2>
                            <p>{t('hero.reportCard.summary')}</p>
                            <a href="#sample-report">{t('hero.reportCard.link')}<ArrowRight size={14} aria-hidden="true" /></a>
                        </div>
                        <span className="landing-photo-caption">{t('hero.photoCaption')}</span>
                    </div>
                </div>
                <div className="landing-reassurance">
                    {[
                        { icon: Phone, key: 'phone' },
                        { icon: Languages, key: 'language' },
                        { icon: CheckCheck, key: 'report' },
                    ].map(({ icon: Icon, key }) => <div key={key}><Icon size={20} strokeWidth={1.6} aria-hidden="true" /><span>{t(`hero.reassurance.${key}`)}</span></div>)}
                </div>
            </div>
        </section>
    );
}
